import { getArrayOfElements } from '../lib/utils';
import { computePosition } from '@floating-ui/dom';
import { autoUpdate, flip, shift, offset, arrow } from '@floating-ui/dom';

function init(button, id) {
  const content = button.dataset.tooltip;
  const placement = button.dataset.tooltipPlacement ?? 'bottom';
  const idPrefix = button.dataset.tooltipIdPrefix ?? 'tooltip-';
  const appendTo = button.dataset.tooltipAppendTo ?? 'body';

  id = `${idPrefix}${id}`;
  let appendToElement;
  if (appendTo === 'body') {
    appendToElement = document.body;
  } else if (appendTo === 'parent') {
    appendToElement = button.parentElement;
  } else {
    appendToElement = document.querySelector(appendTo);
  }

  if (!appendToElement) {
    console.warn(`tooltip's append to element doesn't exist: ${appendTo}`);
    return;
  }

  let autoUpdateCleanup, tooltipElement, innerElement, arrowElement;
  const showTooltip = () => {
    if (!tooltipElement) {
      tooltipElement = document.createElement('div');
      tooltipElement.classList.add('tooltip');
      tooltipElement.setAttribute('role', 'tooltip');
      tooltipElement.id = id;

      innerElement = document.createElement('div');
      innerElement.classList.add('tooltip__inner');
      innerElement.innerText = content;
      tooltipElement.appendChild(innerElement);

      arrowElement = document.createElement('div');
      arrowElement.classList.add('tooltip__arrow');
      tooltipElement.appendChild(arrowElement);
    }
    button.setAttribute('aria-describedby', id);
    appendToElement.appendChild(tooltipElement);

    autoUpdateCleanup = autoUpdate(button, tooltipElement, () => {
      computePosition(button, tooltipElement, {
        placement,
        middleware: [offset(12), flip(), shift({ padding: 8 }), arrow({ element: arrowElement })],
      }).then(({ x, y, placement, middlewareData }) => {
        const side = placement.split('-')[0];
        tooltipElement.dataset.position = side;
        Object.assign(tooltipElement.style, { top: `${y}px`, left: `${x}px` });

        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        const arrowSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right',
        }[side];

        Object.assign(arrowElement.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : '',
          right: '',
          bottom: '',
          [arrowSide]: `-${arrowElement.offsetHeight / 2}px`,
        });
      });
    });
  };

  const hideTooltip = () => {
    button.removeAttribute('aria-describedby');

    if (tooltipElement) {
      tooltipElement.remove();
    }

    if (autoUpdateCleanup) {
      autoUpdateCleanup();
      autoUpdateCleanup = null;
    }
  };

  [
    ['mouseenter', showTooltip],
    ['mouseleave', hideTooltip],
    ['focus', showTooltip],
    ['blur', hideTooltip],
  ].forEach(([event, listener]) => {
    button.addEventListener(event, listener);
  });
}

export function tooltip(targets = '[data-tooltip]') {
  const elements = getArrayOfElements(targets);
  elements.forEach((element, idx) => init(element, idx));
}
